const PURCHASE_ORDERS_RELATIVE_INDEX_PATH = 'purchase-orders';

export const PURCHASE_ORDERS_ROUTE_PREFIX = `/dashboard/${PURCHASE_ORDERS_RELATIVE_INDEX_PATH}`;

interface PurchaseOrderRoutes {
  index: {
    getUrl: () => string;
    path: string;
    relativePath: string;
  };
  purchaseOrderDetails: {
    getUrl: (purchaseOrderId: string) => string;
    path: string;
    relativePath: string;
  };
  purchaseOrderEdit: {
    getUrl: (purchaseOrderId: string) => string;
    path: string;
    relativePath: string;
  };
  purchaseOrderItems: {
    getUrl: (purchaseOrderId: string) => string;
    path: string;
    relativePath: string;
  };
  purchaseOrderList: {
    getUrl: () => string;
    path: string;
    relativePath: string;
  };
  purchaseOrderNew: {
    getUrl: () => string;
    path: string;
    relativePath: string;
  };
}

const purchaseOrderRoutes: PurchaseOrderRoutes = {
  index: {
    path: `${PURCHASE_ORDERS_ROUTE_PREFIX}/*`,
    getUrl: () => PURCHASE_ORDERS_ROUTE_PREFIX,
    relativePath: `${PURCHASE_ORDERS_RELATIVE_INDEX_PATH}/*`
  },
  purchaseOrderNew: {
    path: `${PURCHASE_ORDERS_ROUTE_PREFIX}/new`,
    getUrl: () => `${PURCHASE_ORDERS_ROUTE_PREFIX}/new`,
    relativePath: 'new'
  },
  purchaseOrderEdit: {
    path: `${PURCHASE_ORDERS_ROUTE_PREFIX}/:id/edit`,
    getUrl: (purchaseOrderId: string) => `${PURCHASE_ORDERS_ROUTE_PREFIX}/${purchaseOrderId}/edit`,
    relativePath: ':id/edit'
  },
  purchaseOrderDetails: {
    path: `${PURCHASE_ORDERS_ROUTE_PREFIX}/:id/*`,
    getUrl: (purchaseOrderId: string) => `${PURCHASE_ORDERS_ROUTE_PREFIX}/${purchaseOrderId}`,
    relativePath: ':id/*'
  },
  purchaseOrderItems: {
    path: `${PURCHASE_ORDERS_ROUTE_PREFIX}/:id/items`,
    getUrl: (purchaseOrderId: string) => `${PURCHASE_ORDERS_ROUTE_PREFIX}/${purchaseOrderId}/items`,
    relativePath: 'items'
  },
  purchaseOrderList: {
    path: `${PURCHASE_ORDERS_ROUTE_PREFIX}/*`,
    getUrl: () => PURCHASE_ORDERS_ROUTE_PREFIX,
    relativePath: '*'
  }
};

export default purchaseOrderRoutes;
